import type { JWTContextUser } from '@savvy/deprecated-shared/api/user-api';

export function canViewAdminFeatures(user: JWTContextUser | undefined): boolean {
  if (!user) {
    return false;
  }

  return user.role === 'ADMIN' || user.role === 'ADMIN_CSA' || user.role === 'CSA' || user.role === 'READ_ONLY_ADMIN'; // TODO: should CSA be removed?
}
